import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PesapalRes } from '../constant/types';

@Injectable({
  providedIn: 'root'
})
export class PesapalService {
  baseUrl:string= environment.baseUrl
  constructor(private httpClient:HttpClient) { }

  getPesapalUrl(data:PesapalRes):Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/pesapal`,data)
  }
}
